import { useNavigate } from 'react-router-dom'
import { LogOut, Menu, User } from 'lucide-react'
import { clearAuthData } from '../services/authStorage'
import { API_BASE_URL } from '../config/env'

const Header = ({ onOpenSidebar }) => {
	const navigate = useNavigate()
	const username = localStorage.getItem('username') || 'Usuario'

	const handleLogout = () => {
		clearAuthData()
		navigate('/login', { replace: true })
	}

	return (
		<header className="border-b border-gray-200 bg-white">
			<div className="flex items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
				<div className="flex items-center gap-3">
					<button
						type="button"
						onClick={onOpenSidebar}
						className="text-gray-500 hover:text-gray-700 md:hidden"
						aria-label="Abrir menu"
					>
						<Menu className="h-6 w-6" />
					</button>
					<div className="hidden sm:block">
						<p className="text-xs uppercase tracking-wide text-gray-400">API</p>
						<p className="text-xs font-mono text-gray-600">{API_BASE_URL}</p>
					</div>
				</div>

				<div className="flex items-center gap-4">
					<div className="flex items-center gap-2">
						<User className="h-5 w-5 text-gray-400" />
						<span className="text-sm font-medium text-gray-700">{username}</span>
					</div>
					<button
						onClick={handleLogout}
						className="inline-flex items-center rounded-md border border-transparent bg-red-600 px-3 py-2 text-sm font-medium leading-4 text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
					>
						<LogOut className="mr-2 h-4 w-4" />
						Sair
					</button>
				</div>
			</div>
		</header>
	)
}

export default Header
